<template>
	<div>
		<!-- 商品数据概括 -->
		<div class="shopData">
			<div class="headBs">
				门店数据
			</div>
			<div class="dataMsg">
				<el-row :gutter="30">
					<el-col :span="6">
						<div class="gridContent">
							<p>门店总销售额</p>
							<p>{{list.storeNum}}</p>
							<p><span>生客{{list.guest}}</span><span>熟客{{list.stranger}}</span></p>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="gridContent">
							<p>今日门店订单量</p>
							<p>{{list.orderCount}}</p>
							<p>较前一天
								<i class="el-icon-top" v-if="list.orderbfb[0]!='-'"></i>
								<i class="el-icon-bottom" v-if="list.orderbfb[0]=='-'"></i>
								{{list.orderbfb}}
							</p>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="gridContent">
							<p>今日门店总销售额（元）</p>
							<p>{{list.todaySale}}</p>
							<p>较前一天
								<i class="el-icon-top" v-if="list.yesterdaybfb[0]!='-'"></i>
								<i class="el-icon-bottom" v-if="list.yesterdaybfb[0]=='-'"></i>
								{{list.yesterdaybfb}}
							</p>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="gridContent">
							<p>今日生客/熟客</p>
							<p>{{list.todayGuest}}/{{list.todayStranger}}</p>
							<p style="margin-top:5px;">较前一天生客
								<i class="el-icon-top" v-if="list.guestbfb[0]!='-'"></i>
								<i class="el-icon-bottom" v-if="list.guestbfb[0]=='-'"></i>
								{{list.guestbfb}}
							</p>
							<p style="margin-top:0px;"><span style="margin-right:5px;">较前一天熟客</span>
								<i class="el-icon-top" v-if="list.strangerbfb[0]!='-'"></i>
								<i class="el-icon-bottom" v-if="list.strangerbfb[0]=='-'"></i>
								{{list.strangerbfb}}
							</p>
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :span="6">
						<div class="gridContent">
							<p>门店好评率</p>
							<p>{{list.todayScore}}</p>
							<p>较前一天
								<i class="el-icon-top" v-if="list.yesterdayScorebfb[0]!='-'"></i>
								<i class="el-icon-bottom" v-if="list.yesterdayScorebfb[0]=='-'"></i>
								{{list.yesterdayScorebfb}}
							</p>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="gridContent">
							<p>今日转化率</p>
							<p>{{list.todayScorebfb}}</p>
							较前一天：
							<i class="el-icon-top" v-if="list.yesterdayScorebfb[0]!='-'"></i>
							<i class="el-icon-bottom" v-if="list.yesterdayScorebfb[0]=='-'"></i>
							{{list.yesterdayScorebfb}}
						</div>
					</el-col>
					<el-col :span="12">
						<div class="gridContent">
							<p>门店目标</p>
							<div>月销售：4534111</div>
							<div>月复购：23000</div>
							<div class="progress">
								<div>65%</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 自定义查询 -->
		<el-card class="customQuery">
			<div class="headBs">
				自定查询
			</div>
			<!--  -->
			<div class="dataHead">
				<el-select v-model="form1.name" size="small" placeholder="全部用户" style="width: 150px;">
					<el-option v-for="item in customQuery.user" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-select v-model="form1.time" size="small" placeholder="请选择时间" style="width: 150px;">
					<el-option v-for="item in customQuery.time" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-date-picker v-if="form1.time==4" style="width: 270px;" size="small" value-format="yyyy-MM-dd"
					v-model="form1.times" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<!--  -->
			<div class="dataHead">
				<el-select v-model="form1.city" size="small" placeholder="全部城市" style="width: 150px;">
					<el-option v-for="item in citys" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-select v-model="form1.store" size="small" placeholder="全部店铺" style="width: 150px;">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-button size="small" type="primary" @click="getstore">搜索</el-button>
			</div>
			<!--  -->
			<div style="margin-top: 20px;">
				<div class="check">
					<div v-for="i in mycheckeds" :key="i.value">
						<el-radio v-model="checked" :label="i.value">{{i.label}}</el-radio>
					</div>
				</div>
				<ve-histogram :data="dataComparison" :legend-visible="false" :extend="chartpaihang"></ve-histogram>
			</div>
		</el-card>
		<!--  -->
		<el-card class="customQuery">
			<div class="headBs">
				发型师数据
			</div>
			<div class="dataHead">
				<el-select v-model="form2.time" size="small" placeholder="全部用户" style="width: 150px;">
					<el-option v-for="item in customQuery.time" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-date-picker value-format="yyyy-MM-dd" v-if="form2.time==4" style="width: 270px;" size="small"
					v-model="form2.times" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
				<el-button type="primary" style="margin-left: 10px;" size="small" @click="getworks">
					搜索
				</el-button>
			</div>
			<!--  -->
			<div style="margin-top: 20px;">
				<el-table :height="240" :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="tableData" tooltip-effect="dark" style="width: 100%">
					<el-table-column prop="name" label="发型师"> </el-table-column>
					<el-table-column prop="guestsNum" label="客数"> </el-table-column>
					<el-table-column prop="strangerNum" label="熟客数"> </el-table-column>
					<el-table-column prop="guestNum" label="生客数"> </el-table-column>
					<el-table-column prop="hairs" label="好评率"> </el-table-column>
					<el-table-column prop="telphone" label="订单率"> </el-table-column>
				</el-table>
				<div class="pagesclas">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="form2.pageNum" :page-sizes="[10,20, 30, 40]" :page-size="form2.pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="form2.total">
					</el-pagination>
				</div>
			</div>
		</el-card>
		<!--  -->
		<el-card class="customQuery">
			<div class="headBs">
				历史订单记录
			</div>
			<div class="dataHead" style="display: flex;">
				<div>
					<span>输入搜索：</span>
					<el-input placeholder="订单编号/排队编号/发型师" size="small" v-model="form3.keyword"
						style="width:200px;"></el-input>
				</div>
				<div style="margin-left: 10px;">
					<span>提交时间：</span>
					<el-date-picker value-format="yyyy-MM-dd" v-model="form3.time" size="small" style="width:250px;"
						type="daterange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份">
					</el-date-picker>
				</div>
				<div style="margin-left: 10px;">
					<el-button type="primary" @click="getorder" size="small">搜索</el-button>
				</div>
			</div>
			<!--  -->
			<div style="margin-top: 20px;">
				<div class="table_title">
					<div class="table_title1">数据列表</div>
					<div class="table_title2">
						<el-button type="primary" size="small" @click="expre">导出</el-button>
						<el-select size="small" v-model="form3.status" style="margin-left: 10px;width: 150px;">
							<el-option v-for="item in customQuery.order" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select size="small" v-model="paixus" style="margin-left: 10px;width: 150px;">
							<el-option v-for="item in customQuery.paixu" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="tableData2" tooltip-effect="dark" style="width: 100%">
					<el-table-column prop="orderNo" label="订单编号"> </el-table-column>
					<el-table-column prop="addTime" label="提交时间"> </el-table-column>
					<el-table-column prop="storeName" label="门店"> </el-table-column>
					<el-table-column prop="type" label="服务项目"> </el-table-column>
					<el-table-column prop="goodsTotal" label="订单金额"> </el-table-column>
					<el-table-column prop="payType" label="支付方式"> </el-table-column>
					<el-table-column prop="name" label="发型师"> </el-table-column>
					<el-table-column prop="storeName" label="订单状态"> </el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagesclas">
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
						:current-page="form3.pageNum" :page-sizes="[10,20, 30, 40]" :page-size="form3.pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="form3.total">
					</el-pagination>
				</div>
			</div>
		</el-card>
	</div>
</template>
<script>
	import {
		url
	} from "../../utils/index.js"
	export default {
		data() {
			this.chartpaihang = {
					barWidth: "50%"
				},
				this.chartSettings = {
					stack: {
						'用户': ['销售额', '订单数', '取消订单数', '用户数']
					}
				}
			return {
				id: "",
				url: url(),
				//选择
				checked: "订单数",
				// 用于门店订单筛选
				mycheckeds: [{
					value: "订单数",
					label: "订单数"
				}, {
					value: "销售额",
					label: "销售额"
				}, {
					value: "客数",
					label: "客数"
				}, {
					value: "熟客",
					label: "熟客"
				}, {
					value: "生客",
					label: "生客"
				}, {
					value: "转化率",
					label: "转化率"
				}, {
					value: "复购率",
					label: "复购率"
				}],
				list: {
					id: "",
					// 门店数量
					storeNum: "", //总数
					guest: "", //生客
					stranger: "", //熟客
					//门店订单量
					orderCount: "", //今日门店订单量
					orderbfb: "", //较前一天
					todaySale: "", //今日门店销售额
					yesterdaySale: "",// 今日门店销售总额
					yesterdaybfb: "", // 较前一天
					// 查询今日生客/熟客
					todayStranger: "", //今日熟客
					todayGuest: "", //今日生客
					strangerbfb: "", //较前一天熟客
					guestbfb: "", //较前一天生客
					// 门店好评
					todayScore: "",
					yesterdayScorebfb: "",
					todayScorebfb: "", //今日转化率
					yesterdayScorebfb: "" // 较前一天
				},
				orders: "",
				paixus: "",
				form1: {
					time: "",
					times: ""
				},
				form2: {
					time: "",
					times: "",
					pageNum: 1,
					pageSize: 10,
					total: 0
				},
				form3: {
					status: "",
					keyword: "",
					time: "",
					pageNum: 1,
					pageSize: 10,
					total: 0
				},
				isActive: true,
				value: "",
				customQuery: {
					store: [{
						label: "全部门店",
						value: "全部门店"
					}],
					times: [{
						label: "昨天",
						value: "昨天"
					}],
					city: [{
						label: "全部城市",
						value: "全部城市"
					}],
					time: [{
						label: "全部时间",
						value: ""
					}, {
						label: "昨天",
						value: 1
					}, {
						label: "最近7天",
						value: 2
					}, {
						label: "最近30天",
						value: 3
					}, {
						label: "自定义",
						value: 4
					}, ],
					order: [{
						label: "全部",
						value: ""
					}, {
						label: "待支付",
						value: 2
					}, {
						label: "已取消",
						value: 4
					}, {
						label: "已完成",
						value: 5
					}],
					paixu: [{
						label: "排序方式",
						value: 1
					}, {
						label: "最新订单",
						value: 2
					}, {
						label: "金额优先",
						value: 3
					}]
				},
				//门店数据对比数据
				dataComparison: {
					columns: ['时间', '订单数'],
					rows: [{
						'时间': "8:00",
						'订单数': 0
					}, {
						'时间': "9:00",
						'订单数': 0
					}, {
						'时间': "10:00",
						'订单数': 0
					}, {
						'时间': "11:00",
						'订单数': 0
					}, {
						'时间': "12:00",
						'订单数': 0
					}, {
						'时间': "13:00",
						'订单数': 0
					}, {
						'时间': "14:00",
						'订单数': 0
					}, {
						'时间': "15:00",
						'订单数': 0
					}, {
						'时间': "16:00",
						'订单数': 0
					}, {
						'时间': "17:00",
						'订单数': 0
					}, {
						'时间': "18:00",
						'订单数': 0
					}, {
						'时间': "19:00",
						'订单数': 0
					}, {
						'时间': "20:00",
						'订单数': 0
					}, {
						'时间': "21:00",
						'订单数': 0
					}, {
						'时间': "22:00",
						'订单数': 0
					}, {
						'时间': "23:00",
						'订单数': 0
					}]
				},
				tableData: [],
				tableData2: [],
				citys: [],
				statelist: []
			}
		},
		// 监听
		watch: {
			checked: function() {
				this.getstore()
			}
		},
		mounted() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id
			}
			// 获取城市列表
			this.getcitys()
			//获取门店列表
			this.getstorelist()
			// 获取数据
			this.getlist1()
			// // 获取门店数据
			// this.getstore()
			// // 获取发型师数据
			// this.getworks()
			// // 获取历史订单数据
			// this.getorder()
		},
		methods: {
			//获取城市列表
			getcitys() {
				var provinces = require('province-city-china/dist/city.json');
				this.citys = [{
					value: "",
					label: "全部城市"
				}]
				for (let i = 0; i < provinces.length; i++) {
					var a = {
						label: provinces[i].name,
						value: provinces[i].name
					}
					this.citys.push(a)
				}
			},
			// 获取门店列表
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					if (res.body.code == "200") {
						this.statelist = [{
							value: "",
							label: "全部门店"
						}]
						for (let i in res.body.data) {
							var a = {
								value: res.body.data[i].id,
								label: res.body.data[i].title
							}
							this.statelist.push(a)
						}
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			// 导出订单
			expre() {
				var u = "?keyword=" + this.form3.keyword + "&status=" + this.form3.status
				if (this.id) {
					u = "?keyword=" + this.form3.keyword + "&status=" + this.form3.status + "&storeId=" + this.id
				}
				if (this.form3.time) {
					u += "&startTime=" + this.form3.time[0] + " 00:00:00" + "&endTime" + this.form3.time[1] + "23:59:59"
				}
				window.location.assign(this.url + "storedetails/exporOrderData" + u)
			},
			// 获取历史订单数据
			getorder() {
				var a = {
					keyword: this.form3.keyword, //订单号
					status: this.form3.status, //订单状态
					pageNum: this.form3.pageNum,
					pageSize: this.form3.pageSize
				}
				if (this.id) {
					a.storeId = this.id
				}
				if (this.form3.time) {
					a.startTime = this.form3.time[0]
					a.endTime = this.form3.time[1]
				}
				this.$http.post("storedetails/findDOrderData", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.tableData2 = res.body.data
						this.form3.total = res.body.total
					}
				})
			},
			// 获取发型师数据
			getworks() {
				var a = {
					type: this.form2.time,
					pageNum: this.form2.pageNum,
					pageSize: this.form2.pageSize
				}
				if (this.id) {
					a.storeId = this.id
				}
				if (this.form2.time == 4) {
					if (!this.form2.times) {
						this.$message.error("请选择筛选时间")
						return false
					}
					a.startTime = this.form2.times[0] + " 00:00:00"
					a.endTime = this.form2.times[1] + " 23:59:59"
				}
				this.$http.post("storedetails/findWorkerData", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.tableData = res.body.data
						this.form2.total = res.body.total
					}
				})
			},
			//获取第一部分的数据
			getlist1() {
				var a = {}
				if (this.id) {
					a.storeId = this.id
				}
				// 门店数量
				this.$http.post("storedetails/getStoreCount", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.list.storeNum = res.body.data.storeMoney
						this.list.guest = res.body.data.guest
						this.list.stranger = res.body.data.stranger
					} else {
						this.$message.error(res.msg)
					}
				})
				//今日门店订单量
				this.$http.post("storedetails/getDayStoreOrder", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.list.orderCount = res.body.data.orderCount
						this.list.orderbfb = res.body.data.orderbfb
					}
				})
				// //今日门店订单量
				this.$http.post("storedetails/getDateSaleData", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.list.todaySale = res.body.data.todaySale
						this.list.yesterdaySale = res.body.data.yesterdaySale
						this.list.yesterdaybfb = res.body.data.yesterdaybfb
					}
				})
				// 今日生客熟客
				this.$http.post("storedetails/getStrangerGuest", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.list.todayStranger = res.body.data.todayStranger
						this.list.todayGuest = res.body.data.todayGuest
						this.list.strangerbfb = res.body.data.strangerbfb
						this.list.guestbfb = res.body.data.guestbfb
					}
				})
				// 门店好评率
				this.$http.post("storedetails/getDevaluateScore", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.list.todayScore = res.body.data.todayScore
						this.list.yesterdayScorebfb = res.body.data.yesterdayScorebfb
					}
				})
				// 门店好评率
				this.$http.post("storedetails/getOrderVisitsData", JSON.stringify(a)).then(function(res) {
					if (res.body.code == "200") {
						this.list.todayScorebfb = res.body.data.todayScorebfb
						this.list.yesterdayScorebfb = res.body.data.yesterdayScorebfb
					}
				})
			},
			zhuan(data, name) {
				this.dataComparison.columns = ['时间', name]
				this.dataComparison.rows = [{
					'时间': "8:00",
					[name]: data.time8
				}, {
					'时间': "9:00",
					[name]: data.time9
				}, {
					'时间': "10:00",
					[name]: data.time10
				}, {
					'时间': "11:00",
					[name]: data.time11
				}, {
					'时间': "12:00",
					[name]: data.time12
				}, {
					'时间': "13:00",
					[name]: data.time13
				}, {
					'时间': "14:00",
					[name]: data.time14
				}, {
					'时间': "15:00",
					[name]: data.time15
				}, {
					'时间': "16:00",
					[name]: data.time16
				}, {
					'时间': "17:00",
					[name]: data.time17
				}, {
					'时间': "18:00",
					[name]: data.time18
				}, {
					'时间': "19:00",
					[name]: data.time19
				}, {
					'时间': "20:00",
					[name]: data.time20
				}, {
					'时间': "21:00",
					[name]: data.time21
				}, {
					'时间': "22:00",
					[name]: data.time22
				}, {
					'时间': "23:00",
					[name]: data.time23
				}]
			},
			// 获取订单表图表的数据
			getstore() {
				// 订单数
				var a = {
					type: this.form1.time
				}
				if (this.id) {
					a.storeId = this.id
				}
				if (this.form1.time == 4) {
					if (!this.form1.times) {
						this.$message.error("请选择筛选时间")
						return false
					}
					a.startTime = this.form1.times[0] + " 00:00:00"
					a.endTime = this.form1.times[1] + " 23:59:59"
				}
				if (this.checked == "订单数") {
					this.$http.post("storedetails/getOrderCount", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.zhuan(res.body.data, this.checked)
							return false
						}
					})
				}
				if (this.checked == "销售额") {
					this.$http.post("storedetails/getOrderSale", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.zhuan(res.body.data, this.checked)
							return false
						}
					})
				}
				if (this.checked == "客数") {
					this.$http.post("storedetails/getGuestNum", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.zhuan(res.body.data, this.checked)
							return false
						}
					})
				}
				if (this.checked == "熟客") {
					this.$http.post("storedetails/getGuestData", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.zhuan(res.body.data, this.checked)
							return false
						}
					})
				}
				if (this.checked == "生客") {
					this.$http.post("storedetails/getStrangerData", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.zhuan(res.body.data, this.checked)
							return false
						}
					})
				}
			},
			//翻页
			handleSizeChange(val) {
				this.form2.pageSize = val
				this.getworks()
			},
			handleCurrentChange(val) {
				this.form2.pageNum = val
				this.getworks()
			},
			handleSizeChange2(val) {
				this.form3.pageSize = val
				this.getorder()
			},
			handleCurrentChange2(val) {
				this.form3.pageNum = val
				this.getorder()
			}
		}
	}
</script>
<style lang="less" scoped>
	.headBs {
		font-weight: bold;
		position: relative;

		&::before {
			content: "";
			width: 5px;
			height: 15px;
			display: block;
			border-radius: 2px;
			background-color: #409EFF;
			position: absolute;
			left: -20px;
			top: 3px;
		}
	}

	.shopData {
		width: 100%;
		box-sizing: border-box;
		padding: 10px 20px;
		position: relative;

		.dataMsg {
			width: 100%;

			.el-row {
				margin-top: 20px;

				.el-col {
					border-radius: 5px;

					.gridContent {
						height: 165px;
						padding: 10px;
						box-sizing: border-box;
						background-color: #F2F2F2;
						position: relative;

						p {
							margin: 0;
							margin-top: 12px;
							font-size: 16px;

							&:nth-of-type(2) {
								font-size: 40px;
							}

							&:nth-of-type(3) {
								span {
									&:last-of-type {
										margin-left: 20px;
									}
								}
							}
						}

						div {
							margin-top: 15px;
						}

						.progress {
							width: 60%;
							height: 72px;
							border: 2px solid #409EFF;
							position: absolute;
							top: 40px;
							right: 20px;

							div {
								margin: 0;
								width: 60%;
								background-color: #409EFF;
								height: 72px;
								text-align: center;
								color: #fff;
								line-height: 72px;
								font-size: 30px;
							}
						}
					}
				}
			}
		}
	}

	.customQuery {
		margin-top: 20px;
		padding: 0 20px;

		.dataHead {
			margin-top: 20px;

			.el-select {
				margin-right: 20px;
			}
		}
	}

	.biaoge {
		width: 100%;

		.head {
			width: 100%;
			background-color: #DFDFDF;
			text-align: center;
			color: #8C8C8C;
			padding: 10px 0;
		}
	}

	.table_title {
		border: 1px solid #E4E4E4;
		padding: 8px;
		width: 98%;
		display: flex;
		margin-bottom: 15px;
	}

	.table_title1 {
		padding-top: 6px;
		flex: 1;
	}

	.check {
		display: flex;
		width: 80%;
		margin: auto;

		div {
			flex: 1;
		}
	}

	.pagesclas {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>